import axios from "axios";
import { get } from "lodash";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  REQUEST_MASTER_FAQ,
  REQUEST_CREATE_MASTER_FAQ,
  REQUEST_UPDATE_MASTER_FAQ,
  ERROR_DELETE_MASTER_FAQ,
  SET_MASTER_FAQ,
  SUCCESS_CREATE_MASTER_FAQ,
  SUCCESS_UPDATE_MASTER_FAQ,
  REQUEST_DELETE_MASTER_FAQ,
  ERROR_GET_MASTER_FAQ,
  ERROR_CREATE_MASTER_FAQ,
  ERROR_UPDATE_MASTER_FAQ,
  SUCCESS_DELETE_MASTER_FAQ,
} from "./faqActionTypes";

function* requestMasterFaq(action: Record<string, any>): any {
  try {
    const result: any = yield call(getFaqMaster);
    yield put({ type: SET_MASTER_FAQ, payload: result.data });
    // console.warn(result.data);
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_GET_MASTER_FAQ, payload: message });
  }
}

function* requestUpdateMasterFaq(action: Record<string, any>): any {
  try {
    const result = yield call(
      updateMasterFaq,
      action.data.payload,
      action.data._id
    );
    yield put({
      type: SUCCESS_UPDATE_MASTER_FAQ,
      payload: result.data,
    });
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_UPDATE_MASTER_FAQ, payload: message });
  }
}

function* requestCreateMasterFaq(action: Record<string, any>): any {
  try {
    const result = yield call(createMasterFaq, action.payload);
    yield put({
      type: SUCCESS_CREATE_MASTER_FAQ,
      payload: result.data,
    });
    // update relevant category as well
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_CREATE_MASTER_FAQ, payload: message });
  }
}

function* requestDeleteMasterFaq(action: Record<string, any>): any {
  try {
    yield call(deleteMasterFaq, get(action, "payload._id", ""));
    yield put({
      type: SUCCESS_DELETE_MASTER_FAQ,
      payload: get(action, "payload._id", ""),
    });
  } catch (error: any) {
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_DELETE_MASTER_FAQ, payload: message });
  }
}

export function getFaqMaster() {
  return axios({
    method: "GET",
    url: `${process.env.REACT_APP_BASE_URL}/faq`,
    withCredentials: true,
  });
}

export function updateMasterFaq(payload: Record<string, any>, _id: string) {
  return axios({
    method: "patch",
    url: `${process.env.REACT_APP_BASE_URL}/faq/${_id}`,
    data: payload,
    withCredentials: true,
  });
}

export function createMasterFaq(payload: Record<string, any>) {
  return axios({
    method: "post",
    url: `${process.env.REACT_APP_BASE_URL}/faq`,
    data: payload,
    withCredentials: true,
  });
}

export function deleteMasterFaq(_id: string) {
  return axios({
    method: "delete",
    url: `${process.env.REACT_APP_BASE_URL}/faq/${_id}`,
    withCredentials: true,
  });
}

const faqMasterSaga = function* () {
  yield all([
    takeLatest(REQUEST_MASTER_FAQ, requestMasterFaq),
    takeLatest(REQUEST_UPDATE_MASTER_FAQ, requestUpdateMasterFaq),
    takeLatest(REQUEST_CREATE_MASTER_FAQ, requestCreateMasterFaq),
    takeLatest(REQUEST_DELETE_MASTER_FAQ, requestDeleteMasterFaq),
  ]);
};

export default faqMasterSaga;
